import Shepherd from 'shepherd.js';
import { i18n } from '@/i18n';
import { defaultTourSettings, defaultStepSettings, startText, backText, finishText } from './shepherd_defaults.js';

const shepherdTour = new Shepherd.Tour({
    ...defaultTourSettings,
});

shepherdTour.addStep({
    click: function () {
        return shepherdTour.next;
    },
    arrow: true,
    classes: 'shepherd-dialog',
    id: '1',
    text: () => i18n.t('tour.step1'),
    buttons: [
        {
            classes: 'myprovet-shepherd-btn-next',
            text: startText,
            action: shepherdTour.next,
        },
    ],
});

shepherdTour.addStep({
    click: function () {
        return shepherdTour.next;
    },
    ...defaultStepSettings(shepherdTour),
    id: '2',
    text: () => i18n.t('tour.step2'),
    attachTo: {
        element: '.shepherd-dashboard-link',
        on: 'bottom-end',
    },
});

shepherdTour.addStep({
    click: function () {
        return shepherdTour.next;
    },
    ...defaultStepSettings(shepherdTour),
    id: '3',
    text: () => i18n.t('tour.step3'),
    attachTo: {
        element: '.shepherd-navbar-branch-selector',
        on: 'bottom',
    },
});

shepherdTour.addStep({
    click: function () {
        return shepherdTour.next;
    },
    ...defaultStepSettings(shepherdTour),
    id: '4',
    text: () => i18n.t('tour.step4'),
    attachTo: {
        element: '.shepherd-navbar-tools',
        on: 'bottom',
    },
});

shepherdTour.addStep({
    click: function () {
        return shepherdTour.next;
    },
    ...defaultStepSettings(shepherdTour),
    id: '5',
    text: () => i18n.t('tour.step5'),
    attachTo: {
        element: '.shepherd-navbar-search',
        on: 'bottom-end',
    },
});

shepherdTour.addStep({
    click: function () {
        return shepherdTour.next;
    },
    ...defaultStepSettings(shepherdTour),
    id: '6',
    text: () => i18n.t('tour.step6'),
    attachTo: {
        element: '.shepherd-navbar-user-menu',
        on: 'bottom-start',
    },
});

shepherdTour.addStep({
    click: function () {
        return shepherdTour.next;
    },
    ...defaultStepSettings(shepherdTour),
    id: '7',
    text: () => i18n.t('tour.step7'),
    attachTo: {
        element: '.shepherd-sidebar-categories-list',
        on: 'right',
    },
});

shepherdTour.addStep({
    click: function () {
        return shepherdTour.next;
    },
    ...defaultStepSettings(shepherdTour),
    id: '8',
    text: () => i18n.t('tour.step8'),
    attachTo: {
        element: '.shepherd-dashboard-shortcuts',
        on: 'right',
    },
});

shepherdTour.addStep({
    click: function () {
        return shepherdTour.next;
    },
    ...defaultStepSettings(shepherdTour),
    id: '9',
    text: () => i18n.t('tour.step9'),
    attachTo: {
        element: '.shepherd-dashboard-shortcuts-button',
        on: 'bottom',
    },
});

shepherdTour.addStep({
    click: function () {
        return shepherdTour.next;
    },
    ...defaultStepSettings(shepherdTour),
    id: '10',
    text: () => i18n.t('tour.step10'),
    attachTo: {
        element: '.shepherd-dashboard-campaigns',
        on: 'left',
    },
});

shepherdTour.addStep({
    click: function () {
        return shepherdTour.next;
    },
    ...defaultStepSettings(shepherdTour),
    id: '11',
    text: () => i18n.t('tour.step11'),
    attachTo: {
        element: '.shepherd-dashboard-propec-info',
        on: 'right',
    },
});

shepherdTour.addStep({
    click: function () {
        return shepherdTour.next;
    },
    ...defaultStepSettings(shepherdTour),
    id: '12',
    text: () => i18n.t('tour.step12'),
    attachTo: {
        element: '.shepherd-myprovet-footer',
        on: 'top',
    },
});

shepherdTour.addStep({
    click: function () {
        return shepherdTour.next;
    },
    arrow: true,
    id: '13',
    text: () => i18n.t('tour.step13'),
    attachTo: {
        element: '.shepherd-feedback-button',
        on: 'left',
    },
    classes: 'shepherd-dialog',
    buttons: [
        {
            classes: 'myprovet-shepherd-btn-back',
            text: backText,
            action: shepherdTour.back,
        },
        {
            classes: 'myprovet-shepherd-btn-next',
            text: finishText,
            action: shepherdTour.next,
        },
    ],
});

export default shepherdTour;
